import React from "react";

export default function AgreementStatus({status}) {
    return (

        <div className={status === 'ACCEPTED' ? "agreement-status" : "agreement-status agreement-status--disabled"}>{status}</div>

    );
};